<template>
  <div
    class="item"
    @click="goToItem(item.id)"
  >
    <div class="name-description-container w-full flex-no-shrink">
      <div class="name font-bold">
        {{ item.name }}
      </div>
      <p
        :class="{ 'hide-text': item.description.length == 0 }"
        class="description w-full text-sm"
      >
        {{ item.description ? item.description : "." }}
      </p>
    </div>
    <div class="drag-button handle">
      <div>..<br>..<br>..<br>..</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  methods: {
    goToItem(id) {
      this.$router.push({ name: "item", params: { id: id } });
    },
  },
};
</script>

<style>
.item {
  @apply flex items-center flex-wrap shadow mb-2 py-2 px-2 rounded bg-white text-grey-darkest no-underline;
}

.drag-button {
  color: darkgray;
  cursor: move;
  cursor: grab;
  font-size: 20px;
  flex: 1;
  align-self: stretch;
  line-height: 30%;
  font-size: 22px;
}

.hide-text {
  color: white !important;
}

.drag-button:hover,
.drag-button:active {
  color: rgb(87, 87, 87);
  font-weight: 500;
}

.drag-button div {
  margin-left: auto;
  padding-right: 10px;
  width: fit-content;
}

.name {
  margin-bottom: 4px;
}

.name-description-container {
  width: 93%;
}

@media screen and (max-width: 399px) {
  .name-description-container {
    width: 90%;
  }
}

@media screen and (max-width: 299px) {
  .name-description-container {
    width: 85%;
  }
}
</style>